import React from 'react'
import { CSVRow } from '../importer-types'

export function DebugTable({ data }: { data: CSVRow[] }) {
  if (data.length === 0) {
    return <div className="text-gray-500">No data to display</div>
  }

  // Get all keys from the first row to use as headers
  const allKeys = Object.keys(data[0])

  const formatValue = (value: unknown): string | React.JSX.Element => {
    if (value === null || value === undefined) {
      return <span className="text-gray-400 italic">&lt;NULL&gt;</span>
    }
    if (value === '') {
      return <span className="text-gray-400 italic">&lt;EMPTY&gt;</span>
    }
    return JSON.stringify(value, null, 2)
  }

  return (
    <div className="max-h-[600px] overflow-auto border border-gray-300">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-100 sticky top-0 z-10">
          <tr>
            {allKeys.map((key) => (
              <th
                key={key}
                className="border border-gray-300 px-2 py-1 text-left font-semibold bg-gray-100"
              >
                {key}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx} className="hover:bg-gray-50">
              {allKeys.map((key) => {
                const formatted = formatValue(row[key])
                return (
                  <td key={key} className="border border-gray-300 px-2 py-1">
                    <div className="max-h-32 overflow-auto">
                      {typeof formatted === 'string' ? (
                        <pre className="text-xs whitespace-pre-wrap font-mono">
                          {formatted}
                        </pre>
                      ) : (
                        formatted
                      )}
                    </div>
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
